import tailwindColors from '../../../stylesheets/tailwind.config.colors';

export const getTailwindColor = (color: string, grade: number): string => tailwindColors[color.toLowerCase()][grade];
